class ColourWheel extends HTMLElement {
  constructor() {
    super();

    this.segments = this.querySelectorAll(".js-colour-wheel-segment");
    this.content = this.querySelector(".js-shop-colour-content");
    this.swatch = this.querySelector(".js-shop-colour-swatch");
    this.name = this.querySelector(".js-shop-colour-name");
    this.description = this.querySelector(".js-shop-colour-description");
    this.cta = this.querySelector(".js-shop-colour-cta");
    this.activeSegment = this.querySelector(".js-colour-wheel-segment.active");

    if (this.segments.length) this.addListeners();
  }

  addListeners() {
    this.segments.forEach((segment) => {
      segment.addEventListener("mouseover", () => this.changeWheelColour(segment));

      segment.addEventListener("click", () => this.handleListener(segment));
    });
  }

  handleListener(segment) {
    if (this.activeSegment === segment) return;

    this.activeSegment?.classList.remove("active");

    this.changeWheelColour(segment);
    this.activateSegment(segment);
  }

  changeWheelColour(segment) {
    const colourName = segment.getAttribute("data-colour");

    segment
      .closest(".colour-wheel__wrapper")
      .setAttribute("data-after", colourName);
  }

  activateSegment(segment) {
    this.activeSegment = segment;

    segment.classList.add("active");

    this.content.classList.add("js-colour-transition");
    this.content.classList.remove("js-colour-active");

    this.content.addEventListener("animationend", () => {
      this.updateSegment(segment);

      this.content.classList.remove("js-colour-transition");
      this.content.classList.add("js-colour-active");
    }, { once: true });
  }

  updateSegment(segment) {
    const colourName = segment.getAttribute("data-colour");

    if (window.colourDescriptions) {
      window.colourDescriptions.forEach((colour) => {
        if (colour.name === colourName) {
          if (colour.swatch) {
            this.swatch.style.backgroundColor = colour.swatch;
          } else {
            this.swatch.style.backgroundColor = "var(--color-grey-light)";
          }

          if (colour.name) {
            this.name.innerHTML = colour.name;
            this.name.classList.remove("hidden");
          } else {
            this.name.classList.add("hidden");
          }

          if (colour.description) {
            this.description.innerHTML = colour.description;
            this.description.classList.remove("hidden");
          } else {
            this.description.classList.add("hidden");
          }

          if (colour.label && colour.link_override) {
            this.cta.setAttribute("href", colour.link_override);
            this.cta.querySelector("span").innerHTML = colour.label;
            this.cta.classList.remove("hidden");
          } else if (colour.label && colour.collection) {
            this.cta.setAttribute("href", colour.collection);
            this.cta.querySelector("span").innerHTML = colour.label;
            this.cta.classList.remove("hidden");
          } else {
            this.cta.classList.add("hidden");
          }
        }
      });
    }
  }
}

customElements.define("colour-wheel", ColourWheel);
